import { render, staticRenderFns } from "./SameContent.vue?vue&type=template&id=4254716e&scoped=true&"
import script from "./SameContent.vue?vue&type=script&lang=js&"
export * from "./SameContent.vue?vue&type=script&lang=js&"
import style0 from "./SameContent.vue?vue&type=style&index=0&id=4254716e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4254716e",
  null
  
)

export default component.exports